"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.categoryLimits = exports.IntegrationCategory = void 0;
var FeatureFlag_1 = __importDefault(require("@CommonFrontendBackend/FeatureFlag"));
var Zoho_1 = __importDefault(require("./Zoho/Zoho"));
var Pipedrive_1 = __importDefault(require("./PipedriveV2/Pipedrive"));
var Hubspot_1 = __importDefault(require("./Hubspot/Hubspot"));
var Types_1 = require("@CommonFrontendBackend/Account/Types");
var IntegrationCategory;
(function (IntegrationCategory) {
    IntegrationCategory["Remarketing"] = "Remarketing";
    IntegrationCategory["Accounting"] = "Accounting";
    IntegrationCategory["Communication"] = "Communication";
    IntegrationCategory["Payments"] = "Payments";
    IntegrationCategory["CRM"] = "CRM";
    IntegrationCategory["InteractionRecording"] = "Interaction Recording";
    IntegrationCategory["LiveChat"] = "Live Chat";
    IntegrationCategory["Analytics"] = "Analytics";
    IntegrationCategory["ProjectManagement"] = "Project Management";
    IntegrationCategory["Zapier"] = "Sync with 700+ apps";
})(IntegrationCategory = exports.IntegrationCategory || (exports.IntegrationCategory = {}));
exports.categoryLimits = (_a = {},
    _a[IntegrationCategory.InteractionRecording] = 1,
    _a);
exports.default = (function (imageLocation, usingFeature, account) {
    var e_1, _a;
    var XeroSettings = require("./Xero/XeroSettings.js");
    var FreshBooks = require("./FreshBooks/FreshBooks");
    var QuickBooks = require("./QuickBooks/QuickBooks.js");
    var Slack = require("./Slack/Slack.js");
    var Stripe = require("./Stripe/Stripe");
    var Pipedrive = require("./Pipedrive/Pipedrive");
    var Olark = require("./Olark/Olark");
    var MixPanel = require("./MixPanel/MixPanel");
    var Hotjar = require("./Hotjar/Hotjar");
    var FullStory = require("./FullStory/FullStory");
    var CrazyEgg = require("./CrazyEgg/CrazyEgg");
    var GoogleAnalytics = require("./GoogleAnalytics/GoogleAnalytics");
    var HeapAnalytics = require("./HeapAnalytics/HeapAnalytics");
    var Slaask = require("./Slaask/Slaask");
    var Crisp = require("./Crisp/Crisp");
    var Intercom = require("./Intercom/Intercom");
    var Facebook = require("./Facebook/Facebook");
    var GoogleAdwords = require("./GoogleAdwords/GoogleAdwords");
    var AdRoll = require("./AdRoll/AdRoll");
    var Drift = require("./Drift/Drift");
    var IntegrationsImageBase = "Assets/Images/integrations";
    var integrationPlatforms = [
        {
            name: "Zoho CRM",
            categories: [IntegrationCategory.CRM],
            internalName: "zohoIntegrationsPlatform",
            urlSafeName: "zoho",
            logo: "".concat(IntegrationsImageBase, "/zoho-logo.png"),
            ctrl: Zoho_1.default,
            overview: "Automatically create pages from within Qwilr using data from your records in Zoho CRM.",
            features: ["Automate data from Zoho CRM's Accounts, Contacts, Deals, Leads and Quotes records"],
            helplink: "https://help.qwilr.com/article/759-adding-zoho-crm-tokens-to-qwilr-pages",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/zoho-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/zoho-logo-icon.png"),
            circleIcon: true,
        },
        {
            name: "Facebook",
            overview: "Set up your retargeting pixel with Facebook.",
            internalName: "facebook",
            categories: [IntegrationCategory.Remarketing],
            logo: "".concat(IntegrationsImageBase, "/facebook-logo.svg"),
            ctrl: Facebook,
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/facebook-feature.png"),
            },
            helplink: "https://help.qwilr.com/article/277-facebook",
            headerLogo: "".concat(IntegrationsImageBase, "/facebook-logo-icon.svg"),
        },
        {
            name: "Google AdWords",
            overview: "Set up your remarketing pixel with Google AdWords.",
            internalName: "googleAdwords",
            urlSafeName: "google-adwords",
            categories: [IntegrationCategory.Remarketing],
            logo: "".concat(IntegrationsImageBase, "/google-dwords-logo.svg"),
            ctrl: GoogleAdwords,
            helplink: "https://help.qwilr.com/article/276-google-adwords",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/google-dwords-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/google-dwords-logo-icon.svg"),
        },
        {
            name: "AdRoll",
            overview: "Set up your retargeting pixel with AdRoll.",
            internalName: "adRoll",
            categories: [IntegrationCategory.Remarketing],
            logo: "".concat(IntegrationsImageBase, "/-droll-logo.svg"),
            ctrl: AdRoll,
            helplink: "https://help.qwilr.com/article/278-adroll",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/-droll-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/-droll-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "FreshBooks",
            categories: [IntegrationCategory.Accounting],
            overview: "Allow pushing of Qwilr quotes to invoices on your FreshBooks account.",
            internalName: "freshbooks",
            logo: "".concat(IntegrationsImageBase, "/freshbooks-logo.svg"),
            ctrl: FreshBooks,
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/freshbooks-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/freshbooks-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "QuickBooks",
            categories: [IntegrationCategory.Accounting],
            internalName: "quickbooks",
            logo: "".concat(IntegrationsImageBase, "/quickbooks-logo.svg"),
            customButton: imageLocation.image("quickbooks.png"),
            ctrl: QuickBooks,
            overview: "Quickbooks helps to track expenses and accounting and paired with Qwilr, you can automatically update contacts or create invoices as soon as your proposals and quotes are accepted.",
            features: [
                "Automatically or manually create an invoice when proposals or quotes are accepted",
                "Automatically update contacts when they accept your projects.",
            ],
            helplink: "https://help.qwilr.com/article/109-quickbooks",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/quickbooks-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/quickbooks-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Slack",
            internalName: "slack",
            categories: [IntegrationCategory.Communication],
            logo: "".concat(IntegrationsImageBase, "/slack-logo.svg"),
            customButton: imageLocation.image("slack.png"),
            ctrl: Slack,
            overview: "Keep your team updated and make progress transparent by automatically sending page updates to Slack.",
            features: ["Update relevant Slack channels when your pages are created, published, viewed, or accepted."],
            helplink: "https://help.qwilr.com/article/104-slack",
            featureImage: {
                backgroundColor: "#4A144B",
                image: "".concat(IntegrationsImageBase, "/slack-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/slack-logo-icon.svg"),
        },
        {
            name: "Stripe",
            categories: [IntegrationCategory.Payments],
            internalName: "stripe",
            logo: "".concat(IntegrationsImageBase, "/stripe-logo.svg"),
            customButton: imageLocation.image("StripeConnectButton.png"),
            ctrl: Stripe,
            overview: "Receive payments directly from your pages and give clients a simple flow to confirm the project.",
            features: [
                "Receive full payments for projects",
                "Receive optional payments for projects",
                "Receive part payments, like deposits, for projects",
            ],
            helplink: "https://help.qwilr.com/article/294-stripe-video",
            featureImage: {
                backgroundColor: "#6772E5",
                image: "".concat(IntegrationsImageBase, "/stripe-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/stripe-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Salesforce",
            categories: [IntegrationCategory.CRM],
            internalName: "sfdc",
            urlSafeName: "salesforce",
            logo: "".concat(IntegrationsImageBase, "/salesforce-logo.svg"),
            overview: "Automatically create pages from within Salesforce and update records as soon as your pages are viewed and accepted.",
            features: ["Automate pages using your Lead, Account, and Opportunity records."],
            helplink: "https://help.qwilr.com/article/119-salesforce",
            featureImage: {
                backgroundColor: "#FFF",
                image: "".concat(IntegrationsImageBase, "/salesforce-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/salesforce-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "HubSpot",
            categories: [IntegrationCategory.CRM],
            internalName: "hubspot",
            logo: "".concat(IntegrationsImageBase, "/hubspot-logo.svg"),
            ctrl: Hubspot_1.default,
            overview: "Speed up sales cycle by creating and sending pages straight to your contacts without ever leaving HubSpot.",
            features: ["Automate pages using your Contact, Company and Deal records."],
            helplink: "https://help.qwilr.com/article/120-hubspot-integration",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/hubspot-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/hubspot-logo-icon.svg"),
            circleIcon: true,
            enableButtonNotes: {
                getText: function () {
                    return usingFeature(FeatureFlag_1.default.OptionalLoginMethods) &&
                        account.authenticationSettings[Types_1.AuthenticationMethod.Hubspot] === Types_1.AuthenticationStatus.Disabled
                        ? "Note: Enabling the HubSpot integration will enable HubSpot SSO in your account Security settings."
                        : undefined;
                },
                helpLink: "https://help.qwilr.com/article/754-setting-login-security-options-for-your-account",
            },
        },
        {
            name: "Hotjar",
            categories: [IntegrationCategory.InteractionRecording],
            overview: "Record real visitors on your Qwilr pages as they interact with the page.",
            internalName: "hotjar",
            logo: "".concat(IntegrationsImageBase, "/hotjar-logo.svg"),
            ctrl: Hotjar,
            helplink: "https://help.qwilr.com/article/304-hotjar-video",
            featureImage: {
                backgroundColor: "#FC1D5B",
                image: "".concat(IntegrationsImageBase, "/hotjar-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/hotjar-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "FullStory",
            categories: [IntegrationCategory.InteractionRecording],
            overview: "Capture pixel-perfect session playback with automatic insights.",
            internalName: "fullStory",
            logo: "".concat(IntegrationsImageBase, "/fullstory-logo.svg"),
            ctrl: FullStory,
            helplink: "https://help.qwilr.com/article/297-fullstory-video",
            featureImage: {
                backgroundColor: "#F5F6F7",
                image: "".concat(IntegrationsImageBase, "/fullstory-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/fullstory-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "CrazyEgg",
            categories: [IntegrationCategory.InteractionRecording],
            overview: "Find out by seeing how users click and scroll through your website.",
            internalName: "crazyEgg",
            logo: "".concat(IntegrationsImageBase, "/crazyegg-logo.svg"),
            ctrl: CrazyEgg,
            helplink: "https://help.qwilr.com/article/302-crazy-egg-video",
            featureImage: {
                backgroundColor: "#EDF5FB",
                image: "".concat(IntegrationsImageBase, "/crazyegg-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/crazyegg-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Olark",
            categories: [IntegrationCategory.LiveChat],
            overview: "Chat to your customers in real time on any qwilr.",
            internalName: "olark",
            logo: "".concat(IntegrationsImageBase, "/olark-logo.svg"),
            ctrl: Olark,
            helplink: "https://help.qwilr.com/article/96-olark",
            featureImage: {
                backgroundColor: "#2A2828",
                image: "".concat(IntegrationsImageBase, "/olark-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/olark-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Slaask",
            categories: [IntegrationCategory.LiveChat],
            overview: "Chat to your customers in real time on any qwilr.",
            internalName: "slaask",
            logo: "".concat(IntegrationsImageBase, "/slaask-logo.svg"),
            ctrl: Slaask,
            helplink: "https://help.qwilr.com/article/95-slaask",
            featureImage: {
                backgroundColor: "#EFF3F6",
                image: "".concat(IntegrationsImageBase, "/slaask-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/slaask-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Crisp",
            categories: [IntegrationCategory.LiveChat],
            overview: "Chat to your customers in real time on any qwilr.",
            internalName: "crisp",
            logo: "".concat(IntegrationsImageBase, "/crisp-logo.svg"),
            ctrl: Crisp,
            helplink: "https://help.qwilr.com/article/307-crisp-video",
            featureImage: {
                backgroundColor: "#F2F4F6",
                image: "".concat(IntegrationsImageBase, "/crisp-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/crisp-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Intercom",
            categories: [IntegrationCategory.LiveChat],
            internalName: "intercom",
            logo: "".concat(IntegrationsImageBase, "/intercom-logo.svg"),
            ctrl: Intercom,
            overview: "Intercom helps you target and relevantly communicate with your customers on your website, app, or by email. With Qwilr, you can automate your nurture campaigns and quickly react to sales opportunities.",
            features: [
                "Add new Intercom leads when new Qwilr pages are accepted",
                "Automaticaly trigger Intercom campaigns when clients accept your proposal or quote",
            ],
            helplink: "https://help.qwilr.com/article/298-intercom-video",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/intercom-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/intercom-logo-icon.svg"),
        },
        {
            name: "Mixpanel",
            categories: [IntegrationCategory.Analytics],
            overview: "Dive even deeper into what your clients care about inside your Qwilr pages.",
            internalName: "mixPanel",
            logo: "".concat(IntegrationsImageBase, "/mixpanel-logo.svg"),
            ctrl: MixPanel,
            helplink: "https://help.qwilr.com/article/301-mixpanel-video",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/mixpanel-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/mixpanel-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Google Analytics",
            categories: [IntegrationCategory.Analytics],
            overview: "Dive even deeper into what your clients care about inside your Qwilr pages.",
            internalName: "googleAnalytics",
            urlSafeName: "google-analytics",
            logo: "".concat(IntegrationsImageBase, "/google-analytics-logo.svg"),
            ctrl: GoogleAnalytics,
            helplink: "https://help.qwilr.com/article/305-google-analytics-video",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/google-analytics-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/google-analytics-logo-icon.svg"),
        },
        {
            name: "Heap",
            categories: [IntegrationCategory.Analytics],
            overview: "Dive even deeper into what your clients care about inside your Qwilr pages.",
            internalName: "heapAnalytics",
            urlSafeName: "heap-analytics",
            logo: "".concat(IntegrationsImageBase, "/heap-logo.svg"),
            ctrl: HeapAnalytics,
            helplink: "https://help.qwilr.com/article/303-heap-video",
            featureImage: {
                backgroundColor: "#62299B",
                image: "".concat(IntegrationsImageBase, "/heap-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/heap-logo-icon.svg"),
        },
        {
            name: "Drift",
            internalName: "drift",
            logo: "".concat(IntegrationsImageBase, "/drift-logo.svg"),
            categories: [IntegrationCategory.LiveChat],
            overview: "Chat to your customers in real time on any Qwilr page.",
            helplink: "https://help.qwilr.com/article/365-drift",
            featureImage: {
                backgroundColor: "#0198FF",
                image: "".concat(IntegrationsImageBase, "/drift-feature.png"),
            },
            ctrl: Drift,
            headerLogo: "".concat(IntegrationsImageBase, "/drift-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Asana",
            internalName: "asana",
            logo: "".concat(IntegrationsImageBase, "/asana-logo.svg"),
            categories: [IntegrationCategory.ProjectManagement],
            overview: "Asana is a project management tool helping teams to stay focused on the goals, projects, and daily tasks that grow business. With Qwilr, you can automate admin processes such as creating tasks and updating projects.",
            features: [
                "Create and update stories, tasks, and projects in Asana when your pages are viewed and accepted",
                "Automatically create pages when Asana tasks are added and updated",
            ],
            helplink: "https://help.qwilr.com/article/293-zapier-video",
            zapierName: "asana",
            featureImage: {
                backgroundColor: "#F2F4F6",
                image: "".concat(IntegrationsImageBase, "/asana-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/asana-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Airtable",
            internalName: "airtable",
            logo: "".concat(IntegrationsImageBase, "/airtable-logo.svg"),
            categories: [IntegrationCategory.Communication, IntegrationCategory.CRM],
            overview: "Airtable is an easy-to-use database allowing you to create tables to keep track of anything, from sales leads to marketing campaigns. With Qwilr, you can keep your client project management progress accurate and up-to-date.",
            features: [
                "Create and update Airtable records for new accepted Qwilr projects",
                "Create personalized pages with information collected or stored in Airtable (including Airtable forms) ",
            ],
            helplink: "https://help.qwilr.com/article/293-zapier-video",
            zapierName: "airtable",
            featureImage: {
                backgroundColor: "#F8F3FE",
                image: "".concat(IntegrationsImageBase, "/airtable-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/airtable-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Podio",
            internalName: "podio",
            logo: "".concat(IntegrationsImageBase, "/podio-logo.svg"),
            categories: [IntegrationCategory.ProjectManagement],
            overview: "Podio helps you collaborate with your team and manage project and tasks. With Qwilr, you can kick-start your workflow once a project is underway and prompt action.",
            features: [
                "Automatically create a task in Podio when your Qwilr page is accepted",
                "Automatically create pages when Podio records are added and updated",
            ],
            helplink: "https://help.qwilr.com/article/293-zapier-video",
            zapierName: "podio",
            featureImage: {
                backgroundColor: "#FFF",
                image: "".concat(IntegrationsImageBase, "/podio-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/podio-logo-icon.svg"),
        },
        {
            name: "Eventbrite",
            internalName: "eventbrite",
            logo: "".concat(IntegrationsImageBase, "/eventbrite-logo.svg"),
            categories: [IntegrationCategory.CRM],
            overview: "Eventbrite makes it simple to create, manage, promote, and sell out your event. With Qwilr, you can personally address attendees without any manual effort.",
            features: [
                "Automatically update events in Eventbrite when a page is accepted or viewed",
                "Automatically create pages when new attendees register for an event",
            ],
            helplink: "https://help.qwilr.com/article/293-zapier-video",
            zapierName: "eventbrite",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/eventbrite-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/eventbrite-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Typeform",
            internalName: "typeform",
            logo: "".concat(IntegrationsImageBase, "/typeform-logo.svg"),
            categories: [IntegrationCategory.Communication],
            overview: "Typeform helps you build engaging and beautiful online forms. With Qwilr, you can create personalized pages to follow up with form respondents.",
            features: [
                "Automatically create pages when someone completes your form. Your page can be automatically personalized based on the data you’ve collected.",
            ],
            helplink: "https://help.qwilr.com/article/293-zapier-video",
            zapierName: "typeform",
            featureImage: {
                backgroundColor: "#FFF",
                image: "".concat(IntegrationsImageBase, "/typeform-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/typeform-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Dasheroo",
            internalName: "dasheroo",
            logo: "".concat(IntegrationsImageBase, "/dasheroo-logo.svg"),
            categories: [IntegrationCategory.Analytics],
            overview: "Dasheroo helps you create dashboards to track your web analytics, email marketing, social media, and marketing and sales data. With Qwilr, you can add add your page analytics to your dashboard.",
            features: ["Automatically update your dashboard in Dasheroo when your pages are accepted."],
            helplink: "https://help.qwilr.com/article/293-zapier-video",
            zapierName: "dasheroo",
            featureImage: {
                backgroundColor: "#FB6042",
                image: "".concat(IntegrationsImageBase, "/dasheroo-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/dasheroo-logo-icon.svg"),
            circleIcon: true,
        },
        {
            name: "Zapier",
            categories: [IntegrationCategory.Zapier],
            internalName: "zapier",
            overview: "Set up a 'zap' to trigger actions on your services from Qwilr",
            logo: "".concat(IntegrationsImageBase, "/zapier-logo.svg"),
            customEnableScreen: require("./Zapier/Zapier").default,
            hidden: true,
            zapierName: "",
            featureImage: {
                backgroundColor: "white",
                image: "".concat(IntegrationsImageBase, "/zapier-logo.svg"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/zapier-logo-icon.svg"),
        },
    ];
    if (usingFeature(FeatureFlag_1.default.XeroIntegration)) {
        integrationPlatforms.push({
            name: "Xero",
            categories: [IntegrationCategory.Accounting],
            internalName: "xero",
            logo: "".concat(IntegrationsImageBase, "/xero-logo.svg"),
            customButton: imageLocation.image("xero.png"),
            ctrl: XeroSettings,
            overview: "Xero helps to track expenses and accounting and paired with Qwilr, you can automatically update contacts or create invoices as soon as your proposals and quotes are accepted.",
            features: [
                "Automatically create invoices in Xero when your pages accepted.",
                "Automatically update contacts when your pages are accepted.",
            ],
            helplink: "https://help.qwilr.com/article/110-xero",
            featureImage: {
                backgroundColor: "#1AB4D7",
                image: "".concat(IntegrationsImageBase, "/xero-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/xero-logo-icon.svg"),
            circleIcon: true,
        });
    }
    if (usingFeature(FeatureFlag_1.default.PipedriveV2)) {
        integrationPlatforms.unshift({
            name: "Pipedrive",
            internalName: "pipedriveIntegrationsPlatform",
            urlSafeName: "pipedrive",
            categories: [IntegrationCategory.CRM],
            overview: "Qwilr's Pipedrive integration helps sales teams close deals faster with automation. Speed up your sales cycle by creating beautiful, personalized proposals, contracts, quotes, customer onboarding documents and more with only a few clicks. Your buyers will be wowed by the beautiful, web-based documents that are personalized uniquely for them.",
            features: [
                "Electronic signatures + payment options.",
                "Tokens to personalize every document.",
                "Engage and upsell buyers with pricing.",
                "Quickly create sales material using the Templates Library.",
                "Track documents with status and expiry.",
            ],
            logo: "".concat(IntegrationsImageBase, "/pipedrive-logo.svg"),
            ctrl: Pipedrive_1.default,
            helplink: "https://help.qwilr.com/article/803-pipedrive-crm-integration-pipedrive-marketplace",
            featureImage: {
                backgroundColor: "#E8EEF1",
                image: "".concat(IntegrationsImageBase, "/pipedrive-v2-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/pipedrive-logo-icon.svg"),
            circleIcon: true,
        });
    }
    if (usingFeature(FeatureFlag_1.default.OptOutPipedriveV2) || !usingFeature(FeatureFlag_1.default.PipedriveV2)) {
        integrationPlatforms.push({
            name: usingFeature(FeatureFlag_1.default.PipedriveV2) ? "Pipedrive (Old)" : "Pipedrive",
            internalName: "pipedrive",
            urlSafeName: usingFeature(FeatureFlag_1.default.PipedriveV2) ? "pipedriveold" : "pipedrive",
            categories: [IntegrationCategory.CRM],
            overview: "Move your leads through pipelines when you quotes are accepted",
            logo: "".concat(IntegrationsImageBase, "/pipedrive-logo.svg"),
            ctrl: Pipedrive,
            helplink: "https://help.qwilr.com/article/118-pipedrive",
            featureImage: {
                backgroundColor: "#FFF",
                image: "".concat(IntegrationsImageBase, "/pipedrive-feature.png"),
            },
            headerLogo: "".concat(IntegrationsImageBase, "/pipedrive-logo-icon.svg"),
            circleIcon: true,
        });
    }
    try {
        for (var integrationPlatforms_1 = __values(integrationPlatforms), integrationPlatforms_1_1 = integrationPlatforms_1.next(); !integrationPlatforms_1_1.done; integrationPlatforms_1_1 = integrationPlatforms_1.next()) {
            var platform = integrationPlatforms_1_1.value;
            if (platform.urlSafeName == null) {
                platform.urlSafeName = platform.internalName.toLowerCase();
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (integrationPlatforms_1_1 && !integrationPlatforms_1_1.done && (_a = integrationPlatforms_1.return)) _a.call(integrationPlatforms_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return integrationPlatforms;
});
